<!-- Orders table -->
@if (data.length > 0) {
  <table mat-table [dataSource]="data" multiTemplateDataRows>
    <ng-container matColumnDef="referenceNumber">
      <th mat-header-cell *matHeaderCellDef id="referenceNumber"> {{ 'common.labels.refNo' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{order.referenceNumber}} </td>
      <td mat-footer-cell *matFooterCellDef class="bold"> {{ 'common.labels.total' | transloco }} </td>
    </ng-container>
    <ng-container matColumnDef="jurisdiction">
      <th mat-header-cell *matHeaderCellDef id="jurisdiction"> {{ 'common.labels.juris' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{ order.jurisdiction | jurisdictionLabel:order.country:order.displayJurisdiction }} </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>
    <ng-container matColumnDef="orderTypeID">
      <th mat-header-cell *matHeaderCellDef id="orderTypeID"> {{ 'common.labels.type' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{ order.orderTypeID | enumLabel:'orderType':order.orderTypeName }} </td>
      <td mat-footer-cell *matFooterCellDef class="bold"> {{ total }} </td>
    </ng-container>
    <ng-container matColumnDef="orderStatusTypeID">
      <th mat-header-cell *matHeaderCellDef id="orderStatusTypeID"> {{ 'common.labels.status' | transloco }} </th>
      <td mat-cell *matCellDef="let order"> {{ order.orderStatusTypeID | enumLabel:'orderStatusType' }} </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    <ng-container matColumnDef="messages">
      <th mat-header-cell *matHeaderCellDef id="messages"></th>
      <td mat-cell *matCellDef="let order">
        @if (order.hasUnreadCustomerMessages) {
          <mat-icon color="accent">mark_unread_chat_alt</mat-icon>
        }
      </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef id="description"> {{ 'common.labels.description' | transloco }} </th>
      <td mat-cell *matCellDef="let order">
        {{ order.description }}
      </td>
      <td mat-footer-cell *matFooterCellDef> </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="navigateToOrder(row.id)"
      tabindex="0" (keydown.enter)="navigateToOrder(row.id)" class="clickable-table-row"></tr>
    <!-- [routerLink]="['/orders', row.id]" -->
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>
}
<!-- End of orders table-->
